import _orderBy from 'lodash/orderBy'
import {
  getOkFirstPartCategories,
  getOkFirstPartLaunchReasons,
} from 'frontend/communications/okFirstPart'
import { sortAlphabetically } from 'frontcore/utils/helpers/formatters'


const stateObj = {
  categories: [],
  launch_reasons: [],
}

const getters = {
  getOkFirstPartCategories (state) {
    return state.categories.filter(category => category.enabled)
  },
  getOkFirstPartCategoryById: (state) => (id) => {
    return state.categories.find(category => category.id === id)
  },
  getOkFirstPartLaunchReasons (state) {
    return state.launch_reasons.filter(category => category.enabled)
  },
  getOkFirstPartLaunchReasonById: (state) => (id) => {
    return state.launch_reasons.find(category => category.id === id)
  },
  getLaunchReasonsAndException: (state) => (exceptions = []) => {
    return state.launch_reasons.filter(launchReason => {
      return launchReason.enabled || exceptions.includes(launchReason.id)
    }).sort(
      sortAlphabetically('name')
    )
  },
}

const mutations = {
  setOkFirstPartCategories (state, categories) {
    state.categories = _orderBy(categories, 'id')
  },
  updateOkFirstPartCategory (state, value) {
    const categoryIndex = state.categories.findIndex(category => category.id === value.id)
    if (categoryIndex !== -1) {
      state.categories.splice(categoryIndex, 1, value)
    }
  },
  setOkFirstPartLaunchReasons (state, launchReasons) {
    state.launch_reasons = _orderBy(launchReasons, 'id')
  },
  updateOkFirstPartLaunchReason (state, value) {
    const launchReasonIndex = state.launch_reasons.findIndex(launchReason => launchReason.id === value.id)
    if (launchReasonIndex !== -1) {
      state.launch_reasons.splice(launchReasonIndex, 1, value)
    }
  },
}

const actions = {
  fetchOkFirstPartCategories ({ commit }) {
    return getOkFirstPartCategories()
      .then((categories) => {
        commit('setOkFirstPartCategories', categories)
      })
  },
  fetchOkFirstPartLaunchReasons ({ commit }) {
    return getOkFirstPartLaunchReasons()
      .then((launchReasons) => {
        commit('setOkFirstPartLaunchReasons', launchReasons)
      })
  },
}

export default {
  actions,
  getters,
  mutations,
  state: stateObj,
}
